<svg
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  class="icon"
  [attr.width]="size"
  [attr.viewBox]="box"
>
  <use [attr.xlink:href]="path"></use>
</svg>
